<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             title="Select an Artwork"
             icon="la la-image"
             :adaptive="false"
             width="1000"
             @closed="resetOnClose && (selected_artwork = preselectedArtwork)">
    <template #body-content>
      <artwork-list v-model="selected_artwork"
                    slim
                    with-detail
                    highlight-selected
                    :banner-suitable-only="bannerSuitableOnly"
                    :feed-suitable-only="feedSuitableOnly"
                    :lock-suitability="lockSuitability" />
    </template>

    <template #body-controls>
      <b-row class="w-100 justify-content-around px-4">
        <b-row class="w-100 align-items-center">
          <b-col v-if="selected_artwork">
            <span class="font-weight-bold">Selected : </span>
            <img :src="selected_artwork.thumbnail_path" class="mr-1" width="50px">
            <span>{{ selected_artwork.original_name }}</span>
          </b-col>

          <b-col v-if="selected_artwork && selected_artwork.artwork_detail"
                 class="d-flex justify-content-center">
            <button class="btn btn-ss-link show-details-btn"
                    type="button"
                    @click="toggleDetails">
              {{ show_details ? `Hide` : `Show` }} Details
              &nbsp;<i :class="`la ${show_details ? `la-angle-down` : `la-angle-right`}`" style="font-size: 1rem;" />
            </button>
          </b-col>

          <!-- Spoof a form submission -->
          <b-col>
            <b-form @submit.stop.prevent="submitCallback">
              <div class="float-right text-right">
                <b-button type="button" class="btn btn-ss-standout"
                          :disabled="nullish(selected_artwork)"
                          @click="() => close(true)">
                  <loader v-if="waiting_callback" small class="mr-2" />
                  Confirm
                </b-button>
                <b-button type="button" class="btn btn-ss-cancel" @click="() => close(false)">
                  <loader v-if="waiting_callback" small class="mr-2" />
                  Cancel
                </b-button>
              </div>
            </b-form>
          </b-col>
        </b-row>
        <artwork-detail-list v-if="show_details && selected_artwork.artwork_detail" :details="selected_artwork.artwork_detail" />
      </b-row>
    </template>
  </vjs-modal>
</template>

<script>

import {
  BForm,
  BButton,
} from 'bootstrap-vue';

import VjsModal from 'VueComponents/VJSModals/VjsModal';
import VjsModalMixin from 'VueComponents/VJSModals/VjsModalMixin';
import ArtworkDetailList from 'VuePartials/Artwork/ArtworkDetailList.vue';
import ArtworkUploaderMixin from 'VuePartials/Artwork/ArtworkUploaderMixin';
import ArtworkList from 'VueComponents/ArtworkList';

export default {
  components: {
    ArtworkList,
    BForm,
    BButton,
    ArtworkDetailList,
    VjsModal,
  },
  mixins: [ArtworkUploaderMixin, VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `artwork-selection`,
    },
    feedSuitableOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    bannerSuitableOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    lockSuitability: {
      type: Boolean,
      required: false,
      default: false,
    },
    preselectedArtwork: {
      type: Object,
      required: false,
      default: null,
    },
    preloadedArtworks: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    resetOnClose: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      show_details: false,
      selected_artwork: this.preselectedArtwork,
    };
  },
  mounted() {
    EventBus.$on("show_artwork_selection_modal", () => {
      this.showModal();
    });

    this.artwork_dropzone_config.dictDefaultMessage = '+';
  },
  methods: {
    close(confirm) {
      this.close_data.confirm = confirm;
      if (confirm) {
        this.close_data.selected_artwork = this.selected_artwork;
      }

      if (this.resetOnClose) this.selected_artwork = this.preselectedArtwork;

      this.complete();
    },
    submitSelection() {
      EventBus.$emit("new_artwork_selected", this.selected_artwork);
      this.closeModal();
    },
    toggleDetails() {
      this.show_details = !this.show_details;
    },
  },

};
</script>
